export const colorExplanation = [
    {
        riskType: 'normal',
        title: "Normal",
        sub_title: "All Health Insights",
        value: "homozygous_reference",


        riskDescription: "A dog with a homozygous reference genotype is considered genetically normal for the tested trait. This means {petName} does not carry any known mutations associated with disease or abnormal characteristics. In this case, {pronoun} has inherited two copies of the reference (wild-type) gene, which represents the typical, healthy form found in most dogs."
    },
    {
        riskType: 'Carrier',
        title: "Carrier",
        sub_title: " One Copy Inherited ",
        value: "missing_genotype",

        riskDescription: "One copy of a known genetic variant linked to this health trait was detected. This may indicate carrier status. For most autosomal recessive traits, carriers typically do not show any symptoms but can pass the variant to their offspring. In some cases (such as incomplete dominance or complex traits), having one copy may cause a mild or partial effect on the trait."
    },
    {
        riskType: 'affected',
        title: "Affected",
        sub_title: " Two Copies Inherited ",
        value: "homozygous_alternate",

        riskDescription: "Two copies of a known risk variant were detected in this gene. This means {petName} is at increased genetic risk of developing the associated condition. However, genetics is only one part of the picture—environmental factors, diet, and lifestyle can also influence whether the condition manifests. Consultation with your veterinarian is recommended to discuss any preventive steps or monitoring that may help maintain {possessivePronoun} health."
    }



]